import { LookupBase, LookupKeys } from '@ag-common-lib/public-api';
import { orderBy } from 'lodash';

export const sortLookupByDescription = (lookup: LookupBase[]): LookupBase[] => {
    if (!lookup?.length) {
        return lookup;
    }
    return orderBy(lookup, ['description']);
};
